module.exports = __webpack_public_path__ + "img/downlight.295ae3e3.jpg";